import React from 'react';
import { useTranslation } from 'react-i18next';
import i18n from 'i18next';

import { Button, Dialog } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';

import AppButton from '../../designe/app-button/AppButton';
import clsx from 'clsx';
import { useStyles } from './ConfirmDialog.styles';
import theme from '../../../styles/theme';

const ConfirmDialog = (props) => {
  const {
    open,
    onClose,
    onSubmit,
    title,
    children,
    confirmTitleKey = 'common.confirm',
    rejectTitleKey = 'common.cancel',
  } = props;
  const { t } = useTranslation();
  const currentLng = i18n.language;
  const { classes } = useStyles(theme);

  return (
    <Dialog
      // fullScreen={true}
      open={open}
      onClose={onClose}>
      <div className={clsx(classes.confirmDialogWrapper)}>
        <div className={classes.confirmDialogHeader}>
          <div className={classes.confirmDialogTitle}>{title}</div>
          <Button onClick={onClose}>
            <CloseIcon />
          </Button>
        </div>
        <div className={classes.confirmDialogContent}>{children}</div>
        <div className={classes.confirmDialogFooter}>
          <AppButton variant="outlined" onClick={onClose}>
            {t(rejectTitleKey)}
          </AppButton>
          <AppButton onClick={onSubmit}>{t(confirmTitleKey)}</AppButton>
        </div>
      </div>
    </Dialog>
  );
};

export default ConfirmDialog;
